export const formValidation = {
  genericErrorMsg: 'Oops! Something went wrong !',
  copyDisabled: 'Only code copied from the editor can be pasted',
  fields: {
    email: {
      isRequired: { message: 'Please enter Email Id' },
      isValid: {
        pattern:
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'Please enter a valid email id',
      },
    },
    name: {
      isRequired: {
        message: 'Please enter a valid name',
      },
    },
    input: {
      isValid: {
        message: 'Something went wrong in input',
      },
    },
    rating: {
      isRequired: {
        message: 'Please give us a rating',
      },
    },
  },
};
